import {ReloadButton,} from '@flexinet/ui-components';

import {Box,} from '@mantine/core';

import {useBillingProviders} from '../hooks/useBillingProviders.ts';

export const ReloadRecordsButton = () => {

    const {reloadRecords} = useBillingProviders();
    return (
        <Box mx='xs'>
            <ReloadButton onClick={() => reloadRecords()}/>
        </Box>
    );
};
